"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AdornmentContainer = void 0;
var tslib_1 = require("tslib");
var React = require("react");
var icon_1 = require("@next-components/icon");
var bos_icon_1 = require("@next-components/bos-icon");
var AdornmentContainer_styled_1 = require("./AdornmentContainer.styled");
var common_types_1 = require("@next-components/common-types");
exports.AdornmentContainer = function (props) {
    var icon = typeof props.adornment === 'object' ? props.adornment : null;
    var text = typeof props.adornment === 'string' ? props.adornment : null;
    if (!icon && !text) {
        return null;
    }
    var iconSize = ((icon && icon.size) || icon_1.defaultSize) + "px";
    var iconStyles = {
        height: iconSize,
        width: iconSize,
    };
    return (React.createElement(AdornmentContainer_styled_1.AdornmentContainerStyled, { className: "adornment-container", position: props.position, site: props.site },
        text && React.createElement("span", { className: "input-unit" }, text),
        props.site === common_types_1.Site.mercedes && (icon === null || icon === void 0 ? void 0 : icon.bosIconVariant) ? (React.createElement(React.Fragment, null,
            React.createElement(bos_icon_1.Icon, { icon: icon.bosIconVariant, className: 'input-icon' }))) : (React.createElement(React.Fragment, null, icon && React.createElement(icon_1.Icon, tslib_1.__assign({ className: 'input-icon', variant: icon.iconVariant }, iconStyles, icon))))));
};
exports.AdornmentContainer.defaultProps = {
    site: common_types_1.Site.bosno,
};
//# sourceMappingURL=AdornmentContainer.js.map